/**
 * Modular What's New registry: one file per module, concatenated here.
 *
 * To add a module: create `moduleEntries/<module>.js` (default-export an array of entries) and
 * spread it below. Entry format: ../README.md.
 *
 * @type {Object[]}
 */
import aiAgentEntries from './aiAgent';
import boboEntries from './bobo';
import happyAiEntries from './happyAi';
import leadsEntries from './leads';
import delegationEntries from './delegation';
import mailEntries from './mail';
import myDayEntries from './myDay';
import statisticsEntries from './statistics';
import teamChatEntries from './teamChat';
import timeTrackingEntries from './timeTracking';
import payrollEntries from './payroll';
import widgetsEntries from './widgets';
import businessAiEntries from './businessAi';
import intelligenceEntries from './intelligence';
import smartFilterEntries from './smartFilter';
import aiAssistantEntries from './aiAssistant';
import utilitiesEntries from './utilities';
import voipEntries from './voip';
import linkedinEntries from './linkedin';
import novoPaymentEntries from './novoPayment';
import driverEntries from './driver';
import serviceEntries from './service';

const moduleEntries = [
  ...aiAgentEntries,
  ...boboEntries,
  ...happyAiEntries,
  ...leadsEntries,
  ...delegationEntries,
  ...mailEntries,
  ...myDayEntries,
  ...statisticsEntries,
  ...teamChatEntries,
  ...timeTrackingEntries,
  ...payrollEntries,
  ...widgetsEntries,
  ...businessAiEntries,
  ...intelligenceEntries,
  ...smartFilterEntries,
  ...aiAssistantEntries,
  ...utilitiesEntries,
  ...voipEntries,
  ...linkedinEntries,
  ...novoPaymentEntries,
  ...driverEntries,
  ...serviceEntries,
];

export default moduleEntries;
